import React from 'react'
import Text from '../../../../components/atoms/text/Text'
import styles from './Prices.module.css'
import Card from '../../../../components/atoms/card/Card'
import { prices, actualizacionPrecios, ordenanzaPrecios } from '../../../../config/index'
import c from 'classnames'
import { VARIANTS } from '../../../../types/Components.types'

const Prices = () => {
  return (
    <>
      <section className={styles.container}>
        <Text weight="500" size="xl" align="center" transform="uppercase" className={styles.title}>
          Precios del coworking
        </Text>

        <Text size="ml" align="center" className={styles.p}>
          Los precios para acceder al coworking dependen del tipo de sitio elegido así como de la franja horaria y de la
          modalidad de la reserva. Los bonos de días sueltos caducan al año de su adquisición. Los precios{' '}
          <Text element="span" weight="600">
            no incluyen IVA
          </Text>
          . A estos precios hay que añadirles el 21% de IVA.
        </Text>

        <Text size="ml" align="center" className={styles.p}>
          Las empresas y autónomos, con domicilio fiscal y/o actividad en San Lorenzo de El Escorial, así como los
          empadronados, disfrutarán de un 20% de descuento.
        </Text>

        <Text size="ml" align="center" className={styles.p}>
          Recuerda que puedes acceder a la ordenandanza con toda la información de los precios del Coworking desde{' '}
          <a href={ordenanzaPrecios} target="_blank" rel="noreferrer">
            aquí
          </a>
          . También puedes consultar la{' '}
          <a href={actualizacionPrecios} target="_blank" rel="noreferrer">
            actualización de los precios oficiales
          </a>
          .
        </Text>

        <Text size="ml" align="center" className={styles.p}>
          El cobro se realizará mediante una pasarela de pagos y podrás pagar con{' '}
          <Text element="span" weight="600">
            Visa
          </Text>{' '}
          o{' '}
          <Text element="span" weight="600">
            Mastercard
          </Text>
        </Text>

        <article className={styles.grid}>
          <Card className={c(styles.detailsBlock, styles.fullAccess)}>
            <Text variant={VARIANTS.white} weight="700" size="xl" align="center">
              Acceso completo
            </Text>

            <div className={styles.priceBlock}>
              <Text variant={VARIANTS.white} size="xl" align="center" weight="700">
                150<span className={styles.super}>€</span>
              </Text>
              <Text variant={VARIANTS.white} size="sm" align="center" transform="uppercase">
                Por mes
              </Text>
            </div>

            <Text variant={VARIANTS.white} size="sm" align="center">
              Con acceso al Coworking desde las 8:00am hasta las 21:00pm.
            </Text>
          </Card>

          <Card className={c(styles.detailsBlock, styles.shiftAccess)}>
            <Text variant={VARIANTS.white} weight="700" size="xl" align="center">
              Por turnos
            </Text>

            <div className={styles.priceBlock}>
              <Text variant={VARIANTS.white} size="xl" align="center" weight="700">
                100<span className={styles.super}>€</span>
              </Text>
              <Text variant={VARIANTS.white} size="sm" align="center" transform="uppercase">
                Por mes
              </Text>
            </div>

            <Text variant={VARIANTS.white} size="sm" align="center">
              Con acceso al Coworking desde las 8:00am hasta las 14:30pm o desde las 15:00pm hasta las 21:00pm.
            </Text>
          </Card>

          <Card className={c(styles.detailsBlock, styles.daysAccess)}>
            <Text variant={VARIANTS.white} weight="700" size="xl" align="center">
              Por días
            </Text>

            <div className={styles.priceBlock}>
              <Text variant={VARIANTS.white} size="xl" align="center" weight="700">
                95<span className={styles.super}>€</span>
              </Text>
              <Text variant={VARIANTS.white} size="sm" align="center" transform="uppercase">
                Bono de 10 días
              </Text>
            </div>

            <Text variant={VARIANTS.white} size="sm" align="center">
              Con acceso al Coworking desde las 8:00am hasta las 21:00pm.
            </Text>
          </Card>

          <Card className={c(styles.detailsBlock, styles.singleDayAccess)}>
            <Text variant={VARIANTS.white} weight="700" size="xl" align="center">
              Día suelto
            </Text>

            <div className={styles.priceBlock}>
              <Text variant={VARIANTS.white} size="xl" align="center" weight="700">
                15<span className={styles.super}>€</span>
              </Text>
              <Text variant={VARIANTS.white} size="sm" align="center" transform="uppercase">
                Único pago
              </Text>
            </div>

            <Text variant={VARIANTS.white} size="sm" align="center">
              Con acceso al Coworking desde las 8:00am hasta las 21:00pm.
            </Text>
          </Card>
        </article>

        <div>
          <a className={styles.button} href={prices} rel="noreferrer" target="_blank">
            Consulta los precios oficiales
          </a>
        </div>
      </section>
    </>
  )
}

export default React.memo(Prices)
